<template>
	<div>
		<Drawer v-model="showModal" width="500px;" title="更多筛选">
			<!--<p :style="pStyle">更多筛选</p>-->
			<div v-if="carLine">
				<div slot="label" class="itemTitle">配送路线</div>
				<!--<Select size="large" v-model="searchParams.lineId" @on-change="changeCarCallback" filterable
				        placeholder="配送路线" clearable>
					<Option v-for="item in carLine" :value="item.id" :key="item.id"
					        :disabled="!item.grouper_ids || !item.grouper_ids.length">{{ item.title }}/{{ item.name }}
					</Option>
				</Select>-->
				<Row type="flex" :gutter="10">
					<Col span="12" class="itemChild">
						<Button :type="!searchParams.lineId?'success':'default'" long size="large" @click="changeCarCallback(0)">
							全部
						</Button>
					</Col>
					<Col span="12" class="itemChild" v-for="item in carLine" :value="item.id" :key="item.id">
						<Button :type="searchParams.lineId==item.id?'success':'default'" long size="large" @click="changeCarCallback(item.id)"
						        :disabled="!item.grouper_ids || !item.grouper_ids.length">
							{{item.title}}/{{item.name}}
						</Button>
					</Col>
				</Row>
			</div>
			<div v-if="$store.state.softwareSetting.openBox==1 && !$route.path.includes('orderSorting')">
				<div slot="label" class="itemTitle">装箱类型</div>
				<Row type="flex" :gutter="10">
					<Col span="12" class="itemChild">
						<Button :type="!searchParams.packingType?'success':'default'" long size="large" @click="changePackingTypeCallback(0)">
							全部
						</Button>
					</Col>
					<Col span="12" class="itemChild">
						<Button :type="searchParams.packingType==1?'success':'default'" long size="large"
						        @click="changePackingTypeCallback(1)">
							散件装箱
						</Button>
					</Col>
					<Col span="12" class="itemChild">
						<Button :type="searchParams.packingType==2?'success':'default'" long size="large"
						        @click="changePackingTypeCallback(2)">
							整件装箱
						</Button>
					</Col>
				</Row>
			</div>
			<div>
				<div slot="label" class="itemTitle">配送方</div>
				<Row type="flex" :gutter="10">
					<Col span="12" class="itemChild">
						<Button :type="!searchParams.distributor?'success':'default'" long size="large" @click="changeDistributorCallback(0)">
							全部
						</Button>
					</Col>
					<Col span="12" class="itemChild">
						<Button :type="searchParams.distributor==1?'success':'default'" long size="large"
						        @click="changeDistributorCallback(1)">
							平台配送
						</Button>
					</Col>
					<Col span="12" class="itemChild">
						<Button :type="searchParams.distributor==2?'success':'default'" long size="large"
						        @click="changeDistributorCallback(2)">
							供应商配送
						</Button>
					</Col>
				</Row>
			</div>
			<div v-if="$store.state.user.userInfo.platform!=CONSTANT.P_LOGIN_TYPE.ADMIN_SUPPLIER">
				<div slot="label" class="itemTitle">供应商</div>
				<!--<Select size="large" v-model="searchParams.supplierId" filterable @on-change="changeSupplierCallback"
				        placeholder="供应商" clearable>
					<Option v-for="item in $store.state.allSuppliers" :value="item.id" :key="item.id">{{item.business_name}}
					</Option>
				</Select>-->
				<Row type="flex" :gutter="10">
					<Col span="12" class="itemChild">
						<Button :type="!searchParams.supplierId?'success':'default'" long size="large" @click="changeSupplierCallback(0)">
							全部
						</Button>
					</Col>
					<Col span="12" class="itemChild" v-for="item in $store.state.allSuppliers" :value="item.id" :key="item.id">
						<Button :type="searchParams.supplierId==item.id?'success':'default'" long size="large"
						        @click="changeSupplierCallback(item.id)">
							{{item.business_name}}
						</Button>
					</Col>
				</Row>
			</div>
			<div style="height: 70px;"></div>
			<div class="demo-drawer-footer">
				<Row type="flex" :gutter="10">
					<Col span="12">
						<Button size="large" long @click="resetData">重置</Button>
					</Col>
					<Col span="12">
						<Button type="primary" size="large" long @click="submitSearchData">确认</Button>
					</Col>
				</Row>

			</div>
		</Drawer>
	</div>
</template>

<script>
	const CONSTANT = require("../../../common/const");
	export default {
		name: "search",
		props: {
			searchParams: {type: Object, default: {}},
			carLine: {type: Array, default: null}
		},
		data() {
			return {
				CONSTANT,
				showModal: false,
				pStyle: {
					fontSize: '20px',
					color: 'rgba(0,0,0,0.85)',
					lineHeight: '24px',
					display: 'block',
					marginBottom: '20px'
				},
			}
		},
		methods: {
			// 展示窗口
			showSearchModal() {
				this.showModal = true;
			},
			// 配送方查询回调
			changeDistributorCallback(event) {
				if (!event) {
					this.searchParams.distributor = null;
				} else {
					this.searchParams.distributor = event;
				}
			},
			// 装箱类型查询回调
			changePackingTypeCallback(event) {
				if (!event) {
					this.searchParams.packingType = null;
				} else {
					this.searchParams.packingType = event;
				}
			},
			// 选择供应商回调
			changeSupplierCallback(event) {
				if (!event) {
					this.searchParams.supplierId = null;
				} else {
					this.searchParams.supplierId = event;
				}
			},
			// 选择路线回调查询
			changeCarCallback(event) {
				if (!event) {
					delete this.searchParams.grouper_ids;
					this.searchParams.lineId = null;
					return;
				}
				let grouper_ids = [];
				for (let i = 0; i < this.carLine.length; i++) {
					if (event == this.carLine[i].id) {
						grouper_ids = this.carLine[i].grouper_ids;
					}
				}
				this.searchParams.grouper_ids = grouper_ids;
				this.searchParams.lineId = event;
			},
			// 重置数据
			resetData() {
				this.searchParams.distributor = null;
				this.searchParams.supplierId = null;
				this.searchParams.lineId = null;
			},
			// 提交数据
			submitSearchData() {
				/*if (!this.currentNumber) {
					return this.$Message.warning("数字为空！");
				}
				// 判断小数点后有没有数字
				if (!this.currentNumber.split(".")[1]) {
					this.currentNumber = this.currentNumber.replace(".", "");
				}*/
				this.$emit('reciveSearchData', {data: Number(this.currentNumber)});
				this.showModal = false;
				// return console.log(Number(this.currentNumber))
			},
		},
		mounted() {
		},
		watch: {}
	}
</script>

<style scoped lang="less">
	.itemTitle {
		height: 35px;
		background-color: #e8eaec;
		line-height: 35px;
		width: 100%;
		padding: 0 20px;
		margin: 10px 0;
	}

	.itemChild {
		margin-bottom: 10px;
	}
</style>



// WEBPACK FOOTER //
// src/components/search/search.vue